import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { ProductClickedProperties } from './types';

export const trackProductClicked = (properties: ProductClickedProperties) =>
    sendAnalyticsEvent<ProductClickedProperties>('Product Clicked', properties);
